import { render, staticRenderFns } from "./FormCategoryProductTreeSelect.vue?vue&type=template&id=5a785fcc"
import script from "./FormCategoryProductTreeSelect.vue?vue&type=script&lang=js"
export * from "./FormCategoryProductTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports